/* eslint-disable no-multi-str */
import { TCMS } from '../../types/cms';
import { renderContent } from '../../utils/cms';

const content: Array<TCMS> = [
    {
        type: 'section-header',
        variant: 'h4',
        content: 'IN RETROSPECT ……………” MATH TALK ___#3',
    },
    {
        type: 'break',
    },

    {
        type: 'break',
    },
    {
        type: 'typography',
        variant: 'h4',
        content: '”Mathematics',
    },
    {
        type: 'break',
    },
    {
        type: 'typography',
        variant: 'body2',
        content: 'EDS Meet a Mathematician Guest Series Session #3',
    },
    {
        type: 'break',
    },
    {
        type: 'typography',
        variant: 'h3',
        content: 'In Retrospect……',
    },
    {
        type: 'typography',
        variant: 'body1',
        content: 'Sad Merchant – Problem Solving Session',
    },
    {
        type: 'typography',
        variant: 'body1',
        content:
            '   We believe that the series of discussions ( ” Mathematics ) that EDS has organized for the benefit of students is providing a great opportunity for them to get first-hand interaction with Mathematicians of repute.',
    },
    {
        type: 'break',
    },
    {
        type: 'list',
        content: [
            'It not only is an opportunity to learn the art of mathematics, but also an opportunity to get to know its impact and applications in different areas of learning.',
            'A window to see what future holds for you, the aspiring mathematicians.',
            'An opportunity to motivate and guide yourself …to mould your own career path.',
            'To think differently.',
            'To think out of the box.',
        ],
        icon: 'arrow',
    },
    {
        type: 'break',
    },
    {
        type: 'typography',
        variant: 'body1',
        content:
            '   It’s heartening to see the willingness of the mathematicians – the experts in the profession – to come forward – to share their experiences, to motivate; to guide the students.',
    },
    {
        type: 'break',
    },
    {
        type: 'typography',
        variant: 'body1',
        content:
            'Our last guest, Prof Gajath has shared with us his feedback and made a few suggestions for the benefit of students as follows.',
    },
    {
        type: 'break',
    },
    {
        type: 'typography',
        variant: 'body1',
        content: '….here are some excerpts – in own words of Prof Gajath:',
        color: 'secondary',
    },
    {
        type: 'break',
    },
    {
        type: 'typography',
        variant: 'body1',
        content: `“ They all want to know quick ways to become researchers 😊.
           `,
    },
    {
        type: 'typography',
        variant: 'body1',
        content: ` One participant asked about practising Olympiad type problems and here is one good source:`,
    },
    {
        type: 'link',
        href: 'https://bmos.ukmt.org.uk/home/bmo.shtml',
        content: 'https://bmos.ukmt.org.uk/home/bmo.shtml (*see below 1)',
    },
    {
        type: 'typography',
        variant: 'body1',
        content: `Unfortunately, Purdue has stopped posting problems as of 2019, but the archive is still there`,
    },
    {
        type: 'typography',
        variant: 'body1',
        content: `and it contains a lot of great problems.`,
    },
    {
        type: 'typography',
        variant: 'body1',
        content: `I also maintain such a web site for the university I work:`,
    },
    {
        type: 'link',
        href: 'https://www.aus.edu/cas/departments/mathematics-and-statistics/about/the-math-problem-of-the-month',
        content: `https://www.aus.edu/cas/departments/mathematics-and-statistics/about/the-math-problem-of-the-month (*see below 3)`,
    },
    {
        type: 'typography',
        variant: 'body1',
        content: `Everybody is welcome to submit solutions. ”`,
    },
];

const Retrospect = (): JSX.Element[] => {
    return renderContent(content);
};
export default Retrospect;
